export enum UserTagType {
    A = 0,
    B = 1
}